
  import pwa from '~/mixins/pages/pwa'
  export default {
    name: 'ThemeStoresMobileIosRatingDisplay',
    mixins: [pwa],
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      }
    },
    methods: {
      getPartialFillWidth() {
        const decimalPart = this.pwa?.pwa_app_settings?.overall_ratings % 1
        return decimalPart ? decimalPart * 100 : 0
      }
    }
  }
